import * as React from "react";
const AutomotiveSVG = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.61328 10.791L6.42493 5.92112C6.60576 4.8362 7.54443 4.04102 8.64431 4.04102H16.0822C17.1821 4.04102 18.1208 4.8362 18.3016 5.92112L19.1133 10.791M5.61328 10.791H19.1133M5.61328 10.791C4.37064 10.791 3.36328 11.7983 3.36328 13.041V15.291C3.36328 16.5337 4.37064 17.541 5.61328 17.541M19.1133 10.791C20.356 10.791 21.3633 11.7983 21.3633 13.041V15.291C21.3633 16.5337 20.356 17.541 19.1133 17.541M5.61328 17.541H19.1133M5.61328 17.541V19.2286C5.61328 20.1605 6.36877 20.916 7.30072 20.916C8.23267 20.916 8.98817 20.1605 8.98817 19.2286V17.541H5.61328ZM19.1133 17.541L19.1132 19.2286C19.1132 20.1605 18.3576 20.916 17.4257 20.916C16.4937 20.916 15.7383 20.1605 15.7383 19.2286V17.541H19.1133Z"
      stroke="#888E9E"
      strokeWidth={1.125}
    />
  </svg>
);
export default AutomotiveSVG;
